import { Box } from '@material-ui/core';

import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { DataRowChip } from '@/components/shared/components/DataRowChip';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface ReadOnlyMultipleValuesDataRowProps {
  valuesArray?: string[];
  label?: string;
}

export const ReadOnlyMultipleValuesDataRow = ({ valuesArray, label }: ReadOnlyMultipleValuesDataRowProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'} gridGap={1}>
      <Font variant="subtitle2" color="textSecondary">
        <Text tId={label} />
      </Font>
      <Box display={'inline-flex'} flexWrap={'wrap'}>
        {valuesArray && valuesArray.length > 0 ? (
          valuesArray.map((value) => <DataRowChip value={value} />)
        ) : (
          <Font variant={'body2'} color={'textSecondary'} style={{ paddingLeft: '6px', paddingTop: '6px' }}>
            -
          </Font>
        )}
      </Box>
      <CustomDivider orientation={'horizontal'} margin={1} />
    </Box>
  );
};
